// src/api/user.js

import service from "./index";

// 网站基础信息
export function getWebsite() {
  return service.get(`/website/`);
}

// 首页
export function getHome() {
  return service.get(`/home/`);
}

// 成功案例分类
export function getExampleType() {
  return service.get(`/exampleType/`);
}

// 成功案例列表
export function getExample(params) {
  return service.get(`/example/`, {
    params,
  });
}

// 案例详情
export function getExampleDetail(params) {
  return service.get(`/exampleDetail/`, { params });
}

// 联系我们
export function geContactUs(params) {
  return service.get(`/contactUs/`, { params });
}

// 获取短信验证码
export function getCode(params) {
  return service.get(`/getCode`, { params });
}

// 注册
export function getRegister(tel, code, account, password) {
  return service.postForm(`/register`, { tel, code, account, password });
}

// 获取图形验证
export function getCaptcha() {
  return service.get(`/captcha`);
}

// 登录
export function getLogin(account, password, captcha_key, captcha_code) {
  return service.postForm(`/login`, {
    account,
    password,
    captcha_key,
    captcha_code,
  });
}
//登录后================================================

// 用户信息
export function getUserInfo() {
  return service.get(`/userInfo`);
}

// 修改用户信息
export function getUpdateUserInfo(avatar, company, email, qq, wechat, contact) {
  return service.postForm(`/updateUserInfo`, {
    avatar,
    company,
    email,
    qq,
    wechat,
    contact,
  });
}

// 发布专利
export function getPublishPatent(formData) {
  return service.post(`/publishPatent`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 我的发布-专利
export function getMyPatent(params) {
  return service.get(`/myPatent`, { params });
}

// 我的发布 - 专利 - 详情;
export function getMyPatentDetail(params) {
  return service.get(`/myPatentDetail`, { params });
}

// 专利修改
export function getUpdatePatent(formData) {
  return service.post(`/updatePatent`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 发布商标
export function getPublishTrademark(formData) {
  return service.post(`/publishTrademark`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 我的发布-商标
export function getMyTrademark(params) {
  return service.get(`/myTrademark`, {
    params,
  });
}

// 我的发布-商标-详情
export function getMyTrademarkDetail(params) {
  return service.get(`/myTrademarkDetail`, { params });
}

// 修改商标
export function getUpdateTrademark(formData) {
  return service.post(`/updateTrademark`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 发布科技成果
export function getPublishAchievement(formData) {
  return service.post(`/publishAchievement`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 我的发布-科技成果
export function getMyAchievement(params) {
  return service.get(`/myAchievement`, {
    params,
  });
}

// 我的发布-科技成果-详情
export function getMyAchievementDetail(params) {
  return service.get(`/myAchievementDetail`, { params });
}

// 修改科技成果
export function getUpdateAchievement(formData) {
  return service.post(`/updateAchievement`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 发布科技求购
export function getPublishWantToBuy(formData) {
  return service.post(`/publishWantToBuy`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 我的发布-科技求购
export function getMyWantToBuy(params) {
  return service.get(`/myWantToBuy`, {
    params,
  });
}

// 我的发布-科技求购-详情
export function getMyWantToBuyDetail(params) {
  return service.get(`/myWantToBuyDetail`, { params });
}

// 修改科技求购
export function getUpdateWantToBuy(formData) {
  return service.post(`/updateWantToBuy`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 发布技术求购
export function getPublishPatentWantToBuy(formData) {
  return service.post(`/publishPatentWantToBuy`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 我的发布-技术求购
export function getMyPatentWantToBuy(params) {
  return service.get(`/myPatentWantToBuy`, {
    params,
  });
}

// 我的发布-技术求购-详情
export function getMyPatentWantToBuyDetail(params) {
  return service.get(`/myPatentWantToBuyDetail`, { params });
}

// 修改技术求购
export function getUpdatePatentWantToBuy(formData) {
  return service.post(`/updatePatentWantToBuy`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 发布商标求购
export function getPublishTrademarkWantToBuy(formData) {
  return service.post(`/publishTrademarkWantToBuy`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 我的发布-商标求购
export function getMyTrademarkWantToBuy(params) {
  return service.get(`/myTrademarkWantToBuy`, {
    params,
  });
}

// 我的发布-商标求购-详情
export function getMyTrademarkWantToBuyDetail(params) {
  return service.get(`/myTrademarkWantToBuyDetail`, { params });
}

// 修改商标求购
export function getUpdateTrademarkWantToBuy(formData) {
  return service.post(`/updateTrademarkWantToBuy`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
//登录后================================================

// 上传图片
export function getUploadImage(formData) {
  return service.post("/uploadImage", formData, {
    headers: {
      "Content-Type": "multipart/form-data", // 必须设置这个头部
    },
  });
}

// 上传文件
export function getUploadFile(formData) {
  return service.post("/uploadFile", formData, {
    headers: {
      "Content-Type": "multipart/form-data", // 必须设置这个头部
    },
  });
}

// 参数字典
export function getParams() {
  return service.get(`/params`);
}

// 开放许可专区
export function getOpenLicense(params) {
  return service.get(`/openLicense`, { params });
}

// 科技成果库
export function getAchievement(params) {
  return service.get(`/achievement`, { params });
}

// 技术需求池
export function getWantToBuy(params) {
  return service.get(`/wantToBuy`, { params });
}

// 待售专利资产
export function getPatentSale(params) {
  return service.get(`/patentSale`, { params });
}

// 专利需求求购
export function getPatentWantToBuy(params) {
  return service.get(`/patentWantToBuy`, { params });
}

// 开放许可
export function getOpenLicense2(params) {
  return service.get(`/openLicense2`, { params });
}

// 付费许可
export function getPaidLicense(params) {
  return service.get(`/paidLicense`, { params });
}

// 商标
export function getTrademark(params) {
  return service.get(`/trademark`, { params });
}

// 商标求购
export function getTrademarkWantToBuy(params) {
  return service.get(`/trademarkWantToBuy`, { params });
}

// 科技成果详情
export function getAchievementDetail(params) {
  return service.get(`/achievementDetail`, { params });
}

// 商标详情
export function getTrademarkDetail(params) {
  return service.get(`/trademarkDetail`, { params });
}

// 专利详情
export function getPatentDetail(params) {
  return service.get(`/patentDetail`, { params });
}

// 隐私政策
export function getPrivacyPolicy() {
  return service.get(`/privacyPolicy`);
}

// 条款和条件
export function getTerm() {
  return service.get(`/term`);
}
